import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {

}


export default new Vuex.Store({
    state
})


// WEBPACK FOOTER //
// ./src/store/index.js